<template>
  <div class="template-mgmt">
    <div class="template-tabs">
      <div v-for="tab in tabs" :key="tab.name" class="template-tab-item"
        :class="{ 'template-tab-active': tab.name === currentTab }" @click="currentTab = tab.name">
        <p>{{ tab.label }}</p>
      </div>
    </div>
    <div class="template-content">
      <component :is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
import TemplateLibrary from "./templateLibrary/index.vue";
import TemplateCategories from "./templateCategories/index.vue";

export default {
  name: "TemplateMgmt",
  components: {
    TemplateLibrary,
    TemplateCategories
  },
  data() {
    return {
      currentTab: "TemplateLibrary",
      tabs: [
        {
          name: "TemplateLibrary",
          label: "模版库管理",
          component: TemplateLibrary
        },
        {
          name: "TemplateCategories",
          label: "模版库分类管理",
          component: TemplateCategories
        }
      ]
    };
  },
  computed: {
    currentComponent() {
      const tab = this.tabs.find(tab => tab.name === this.currentTab);
      return tab ? tab.component : null;
    }
  }
};
</script>

<style scoped>
.template-mgmt {
  background: #ffffff;
}

.template-tabs {
  display: flex;
  padding: 16px;
  border: 0;
  border-bottom: 1px solid #e5e7eb;
  gap: 20px;
}

.template-tab-item {
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

.template-tab-item:hover {
  color: #409eff;
}

.template-tab-active {
  color: #409eff;
  font-weight: 500;
}

.template-content {
  width: 100%;
}
</style>
